import { ApiClient, getTenantApplicationsProductDetailConfiguration } from '@ori/static-api-client';
export var getProductInfoDialogShowMrpStatement = async function getProductInfoDialogShowMrpStatement(_ref) {
  var staticApiUrl = _ref.staticApiUrl,
    tenant = _ref.tenant;
  var client = new ApiClient({
    baseUrl: staticApiUrl
  });
  var _await$getTenantAppli = await getTenantApplicationsProductDetailConfiguration(client, tenant),
    isMrpStatementEnabled = _await$getTenantAppli.data.isMrpStatementEnabled;
  return isMrpStatementEnabled;
};